module.exports = __webpack_public_path__ + "img/icon-close.5045da7c.png";